import anime from 'animejs/lib/anime.es'
import { DEFAULT_INITIAL_SETTINGS } from '../constants/initial-settings'
import { LENIS_SCROLL_GLOBAL } from '../scroll'
import './anime-homepage'
import './anime-funnel'

// animation body loading initial
// const ANIME_LOADING = anime({
//   targets: 'body',
//   opacity: [0, 1],
//   easing: 'easeInQuad',
//   duration: DEFAULT_INITIAL_SETTINGS.animations[`${TEMPLATE_PAGE}_TIME_BODY`],
//   autoplay: false,
// })

const onScrollAnime = (selector, speed = 1000, offset = 0) => {
  const scrollPercent = window.scrollY - selector.offsetTop
  return (scrollPercent + offset) / speed
}

document.onreadystatechange = function () {
  LENIS_SCROLL_GLOBAL.scrollTo('body', {
    duration: 1,
  })

  if (document.readyState === 'complete') {
    document.documentElement.scrollTop = 0
    //ANIME_LOADING.play()
  }
}

export { onScrollAnime }
